<template>
  <span v-if="triggerHistory">
    <v-row v-if="isMobile">
      <v-col cols="12">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('triggersHistories.reference') }}:</span>
              {{ triggerHistory._id }}
            </v-list-item-action-text>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('triggersHistories.triggerReference') }}:</span>
              {{ triggerHistory.trigger.trigger_id }}
            </v-list-item-action-text>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('triggersHistories.triggerName') }}:</span>
              {{ triggerHistory.trigger.trigger_name }}
            </v-list-item-action-text>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('triggersHistories.status') }}:</span>
              {{ getStatusTranslation(triggerHistory.status) }}
            </v-list-item-action-text>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('triggersHistories.date') }}:</span>
              {{ new Date(triggerHistory.date) | moment('DD/MM/YYYY HH:mm:ss') }}
            </v-list-item-action-text>
            <v-list-item-action-text v-if="triggerHistory.source_entity">
              <span class="font-weight-black">{{ $t('triggersHistories.entityId') }}:</span>
              {{ triggerHistory.source_entity.entity_id }}
            </v-list-item-action-text>
            <v-list-item-action-text v-if="triggerHistory.source_entity">
              <span class="font-weight-black">{{ $t('triggersHistories.entityType') }}:</span>
              {{ getEntityTypeTranslation(triggerHistory.source_entity.entity_type) }}
            </v-list-item-action-text>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col md="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ $t('triggersHistories.reference') }}: {{ triggerHistory._id }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('triggersHistories.triggerReference') }}: {{ triggerHistory.trigger.trigger_id }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ $t('triggersHistories.triggerName') }}: {{ triggerHistory.trigger.trigger_name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ $t('triggersHistories.status') }}: {{ getStatusTranslation(triggerHistory.status) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col md="6" class="text-right">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('triggersHistories.date') }}: {{ new Date(triggerHistory.date) | moment('DD/MM/YYYY HH:mm:ss') }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="triggerHistory.source_entity">
              {{ $t('triggersHistories.entityId') }}: {{ triggerHistory.source_entity.entity_id }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="triggerHistory.source_entity">
              {{ $t('triggersHistories.entityType') }}:
              {{ getEntityTypeTranslation(triggerHistory.source_entity.entity_type) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </span>
</template>

<script>
  export default {
    name: 'TriggerHistoryHeader',
    data() {
      return {}
    },
    props: {
      triggerHistory: {
        type: Object,
        default() {
          return {}
        },
        required: true,
      },
    },
    computed: {
      status() {
        return [
          { text: this.$t('triggersHistories.processing'), value: 'processing' },
          { text: this.$t('triggersHistories.success'), value: 'success' },
          { text: this.$t('triggersHistories.error'), value: 'error' },
          { text: this.$t('triggersHistories.relaunched'), value: 'relaunched' },
          { text: this.$t('triggersHistories.relaunchFailed'), value: 'relaunch_failed' },
        ]
      },
      entityTypes() {
        return [
          { text: this.$t('triggersHistories.orderEntity'), value: 'orders' },
          { text: this.$t('triggersHistories.subOrderEntity'), value: 'suborders' },
          { text: this.$t('triggersHistories.returnEntity'), value: 'returns' },
          { text: this.$t('triggersHistories.locationEntity'), value: 'locations' },
          { text: this.$t('triggersHistories.stockTransferEntity'), value: 'stockTransfer' },
          { text: this.$t('triggersHistories.stockParsingEntity'), value: 'stockParsing' },
          { text: this.$t('triggersHistories.transactionEntity'), value: 'transactions' },
          { text: this.$t('triggersHistories.refundEntity'), value: 'refunds' },
        ]
      },
      isMobile() {
        return this.$vuetify.breakpoint.width < 450
      },
    },
    methods: {
      getStatusTranslation: function (statusValue) {
        var status = this.status.find((status) => status.value == statusValue)
        if (status) {
          return status.text
        } else {
          return statusValue
        }
      },
      getEntityTypeTranslation: function (entityTypeValue) {
        var entityType = this.entityTypes.find((entityType) => entityType.value == entityTypeValue)
        if (entityType) {
          return entityType.text
        } else {
          return entityTypeValue
        }
      },
    },
  }
</script>
